








































import { Vue, Component, Mixins, Prop, Watch } from "vue-property-decorator";

import _ from "lodash";

@Component
export default class extends Mixins() {
  @Prop() value!: any;

  @Prop({ default: "default" }) mode!: string;

  @Prop({ default: true }) allowClear!: boolean;

  @Prop() callback?: (...args: any[]) => any;

  value1: any = null;

  searchvalue = "";

  data: any[] = [];

  isMounted = false;

  @Watch("value")
  watchValue(val: any, oldVal: any) {
    // console.log(val);
    // console.log(oldVal);
    if (val) {
      if (Array.isArray(val)) {
        this.value1 = val;
        this.fetch1(this.value1);
      } else {
        this.value1 = String(val);
        this.fetch(this.value1);
      }
    } else {
      this.value1 = null;
    }
  }

  fetch(value: any) {
    this.$store
      .dispatch("api/getStadiums", {
        keyword: value
      })
      .then((res: any) => {
        if (res && res.Data) {
          this.data = res.Data;
        } else {
          this.data = [];
        }
      });
  }

  fetch1(stadiumIds: any) {
    if (!_.isArray(stadiumIds)) {
      stadiumIds = [stadiumIds];
    }

    let keyword = "";

    if (this.searchvalue !== "") {
      keyword = this.searchvalue;
    }

    this.$store
      .dispatch("api/getStadiums", {
        stadium_ids: stadiumIds,
        keyword
      })
      .then((res: any) => {
        if (res && res.Data) {
          this.data = res.Data;
        } else {
          this.data = [];
        }
      });
  }

  handleSearch(value: string) {
    // console.log(value);
    this.searchvalue = value;
    // this.fetch(value);
    this.debouncedFetch();
  }

  handleChange(value: any) {
    // console.log(value);
    this.value1 = value;
    this.$emit("change", value);
    if (this.callback) {
      this.callback(value);
    }
    // if (Array.isArray(value)) {
    //   this.fetch1(value);
    // } else {
    //   this.fetch(value);
    // }
  }

  debouncedFetch: any;

  created() {
    this.debouncedFetch = _.debounce(() => this.fetch(this.searchvalue), 500);
  }

  unmounted() {
    this.debouncedFetch.cancel();
  }

  mounted() {
    const query = { ...this.$route.query };

    let { value } = this;

    if (query.stadium_id) {
      value = query.stadium_id;
    }

    // console.log(value);

    if (value) {
      if (value || value.length > 0) {
        this.value1 = value;
        if (!_.isArray(this.value1)) {
          this.value1 = this.value1.toString();
        }
        this.fetch1(this.value1);
      }
    }
  }
}
